import uiRouter from 'angular-ui-router'
import ngSanitize from 'angular-sanitize'
import * as angular from 'angular'
import 'angular-loading-bar'
import 'angular-local-storage'
import 'angular-ui-notification'
import 'ng-scrollbars'

angular.module('webtrader', [ngSanitize, uiRouter, 'vs-repeat', 'angular-loading-bar', 'LocalStorageModule', 'ui-notification', 'ngScrollbars'])
.config(($httpProvider, $interpolateProvider, $compileProvider, $sceProvider, localStorageServiceProvider, $logProvider, NotificationProvider, ScrollBarsProvider, $qProvider) => {
  $interpolateProvider.startSymbol("[[").endSymbol("]]")
  $httpProvider.defaults.xsrfCookieName = 'csrftoken';
  $httpProvider.defaults.xsrfHeaderName = 'X-CSRFToken';
  $httpProvider.defaults.headers.common['X-CSRFToken'] = csrftoken;
  $httpProvider.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
  $compileProvider.aHrefSanitizationWhitelist(/^\s*(https?|ftp|mailto|sip|skype):/) // allow mailto and such hrefs
  $sceProvider.enabled(false)
  localStorageServiceProvider.setPrefix('webtrader')
  $logProvider.debugEnabled(IS_DEBUG)
  NotificationProvider.setOptions({
      delay: 10000,
      startTop: 380,
      startRight: 23,
      verticalSpacing: 15,
      horizontalSpacing: 15,
      positionX: 'left',
      positionY: 'top',
      closeonClick: false,
      maxCount: 1,
      templateUrl: 'order.notification.html'
  });
  ScrollBarsProvider.defaults = {
      autoHideScrollbar: false,
      theme: 'webtrader',
      scrollInertia: 0,
      axis: 'y',
      advanced: {
        updateOnContentResize: true
      }
  }
}).run(($http, $q, $state) => {
  window['http'] = $http
  window['q'] = $q
  window['$state'] = $state
})
